import { FormControl } from '@angular/forms';
import { Resolution } from '@api-types/enums/resolution.enum';

export interface ForecastVersionSettingsForm {
  includeDataUntil: FormControl<Date | null>;
  isBatchProcessing?: FormControl<boolean>;
  frequency?: FormControl<Resolution>;
  useEndOfMonth?: FormControl<boolean>;
  lastRelevantActualDate?: FormControl<Date | null>;
}

export enum ForecastVersionSettingsFormControlNames {
  INCLUDE_DATA_UNTIL = 'includeDataUntil',
  IS_BATCH_PROCESSING = 'isBatchProcessing',
  FREQUENCY = 'frequency',
  USE_END_OF_MONTH = 'useEndOfMonth',
  LAST_RELEVANT_ACTUAL_DATE = 'lastRelevantActualDate',
}
